









import {WConfTpl, WidgetDefinition, WParamTpl} from '@/components/widgets/WidgetFather'
import {bus} from '@/main'
import SimpleTextWidget from "@/components/widgets/SimpleTextWidget.vue"
import {defineComponent} from "@vue/composition-api"
import {formatNumberWithGrouping} from "@/data/sources/numbers"
import {extractParams, getTitle} from "@/components/widgets/hd/hdCommon"
import {executeQuery} from "@/data/repos/query"

export function config(): WidgetDefinition {
  return {
    ...WConfTpl.Text(),
    widget: "JobsRaisedThisYear",
    title: "Jobs raised this year",
    params: {
      hdPPMRepairAll: {...WParamTpl.hdPPMRepair(), _order: 1},
    },
  }
}

async function dataFetcher(params: any) {
  const p = {...extractParams(params), ...{day: 0, month: 0, year: new Date().getFullYear()}}
  const r = await executeQuery(
    'FMS_DB',
    'jobsRaised',
    {ppmRepair: p.hdPPMRepairAll, category: 0, year: p.year, month: p.month, day: p.day},
  )
  return {value: formatNumberWithGrouping(r[0].Value)}
}


function showDrillDown(params: any) {
  const ddComponent = params.hdPPMRepairAll.value.value === 1 ?
    () => import("@/components/drilldowns/JobsRaisedPPMDrillDown.vue") :
    () => import("@/components/drilldowns/JobsRaisedDrillDown.vue")
  bus.$emit('chartPopup', {
    title: config().title,
    component: ddComponent,
    componentArgs: {
      ...extractParams(params),
      day: 0,
      month: 0,
      year: new Date().getFullYear(),
      hdStatus: 0,
      jobCategory: 0,
      category: 0,
    },
  })
}

async function titleCallback(config: any) {
  return getTitle(config.params)
}

export default defineComponent({
  props: {config: Object},
  components: {SimpleTextWidget},
  setup(props, context) {
    context.emit("config-update", config())
    const chartClickCallback = () => showDrillDown(props.config && props.config.params)
    return {dataFetcher, chartClickCallback, titleCallback}
  },
})
